"use client";
import { cn as t } from "../../utils/cn.js";
import { setComponentColor as z } from "../../utils/setComponentColor.js";
import { useMemo as b, useCallback as m } from "react";
import { stylesSpinner as e } from "./styles.js";
function h(s) {
  const {
    ref: w,
    children: a,
    size: o = "md",
    color: i = "primary",
    label: f,
    labelColor: C = "current",
    classNames: r,
    ...n
  } = s, p = t(e.slots.base, r == null ? void 0 : r.base), l = f || a, c = b(() => l && typeof l == "string" ? l : "", [l]), u = m(
    () => ({
      "aria-label": c,
      className: p,
      style: z(i),
      ...n
    }),
    [c, p, i, n]
  ), y = b(
    () => ({
      wrapper: t(
        e.slots.wrapper,
        e.size[o].wrapper,
        r == null ? void 0 : r.wrapper
      ),
      circle1: t(
        e.slots.circle1,
        e.size[o].circle1,
        r == null ? void 0 : r.circle1
      ),
      circle2: t(
        e.slots.circle2,
        e.size[o].circle2,
        r == null ? void 0 : r.circle2
      ),
      label: t(
        e.slots.label,
        e.size[o].label,
        r == null ? void 0 : r.label
      )
    }),
    [r, o]
  );
  return { label: l, classList: y, getSpinnerProps: u };
}
export {
  h as useSpinner
};
